export default __webpack_public_path__ + "static/media/instant-chat.2ed74923.svg";